export function normalizeWhatsappNumber(number, countryCode = "62") {
  // Remove all non-numeric characters
  let formatted = number.replace(/\D/g, "");

  // Replace `0` prefix with `countryCode`
  if (formatted.startsWith("0")) {
    formatted = countryCode + formatted.substr(1);
  }

  return formatted;
}

export function getWhatsappLink(number, message) {
  const url =
    "https://api.whatsapp.com/send?phone=" +
    number +
    "&text=" +
    encodeURIComponent(message);

  return url;
}
